import {view} from '@sail/ui';

import type {AppConfig} from '@stripe-internal/conversations-assistant';
import {
  AssistantContainer,
  ErrorScreen,
} from '@stripe-internal/conversations-assistant';

export function MobileErrorBoundaryFallback({
  config,
  errorId,
}: {
  config: AppConfig;
  errorId?: string;
}) {
  return (
    <view.div css={{height: '100vh'}}>
      <AssistantContainer header={null}>
        <ErrorScreen config={config} errorId={errorId} />
      </AssistantContainer>
    </view.div>
  );
}
